(function () {
    if (window.__fadeInitDone) return;
    window.__fadeInitDone = true;

    const blocks = document.querySelectorAll('.fade');

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                entry.target.classList.toggle('active', entry.isIntersecting);
            });
        },
        { threshold: 0.5 }
    );

    blocks.forEach(el => observer.observe(el));

    window.addEventListener('DOMContentLoaded', () => {
        const firstBlock = document.querySelector('.text-block');
        if (!firstBlock) return;

        const top =
            firstBlock.offsetTop -
            window.innerHeight / 2 +
            firstBlock.offsetHeight / 2;

        window.scrollTo({ top, behavior: 'smooth' });
    });
})();